<div class="button-container">
  <app-generic-button
    class="button"
    (click)="emitLocation()"
    description="Use GPS position reported by scanner"
    [alwaysShowText]="true"
    [disabled]="location() === undefined"
    [buttonText]="'Use GPS position reported by scanner'"/>
  <app-info-button [message]="message()"/>
</div>
